import { render, staticRenderFns } from "./ShopInfo.vue?vue&type=template&id=64beac12&scoped=true&"
import script from "./ShopInfo.vue?vue&type=script&lang=js&"
export * from "./ShopInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShopInfo.vue?vue&type=style&index=0&id=64beac12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64beac12",
  null
  
)

export default component.exports